/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OfferRequest
 */
export interface OfferRequest {
    /**
     *
     * @type {string}
     * @memberof OfferRequest
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof OfferRequest
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof OfferRequest
     */
    description?: string;
    /**
     *
     * @type {number}
     * @memberof OfferRequest
     */
    discountPercent?: number;
    /**
     *
     * @type {string}
     * @memberof OfferRequest
     */
    status?: OfferRequestStatusEnum;
    /**
     *
     * @type {Date}
     * @memberof OfferRequest
     */
    startsAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof OfferRequest
     */
    expiresAt?: Date;
}

/**
 * @export
 */
export const OfferRequestStatusEnum = {
    Unknown: "Unknown",
    Active: "Active",
    Disabled: "Disabled",
    Archived: "Archived",
} as const;
export type OfferRequestStatusEnum =
    (typeof OfferRequestStatusEnum)[keyof typeof OfferRequestStatusEnum];

/**
 * Check if a given object implements the OfferRequest interface.
 */
export function instanceOfOfferRequest(value: object): value is OfferRequest {
    return true;
}

export function OfferRequestFromJSON(json: any): OfferRequest {
    return OfferRequestFromJSONTyped(json, false);
}

export function OfferRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OfferRequest {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        name: json["name"] == null ? undefined : json["name"],
        description:
            json["description"] == null ? undefined : json["description"],
        discountPercent:
            json["discountPercent"] == null
                ? undefined
                : json["discountPercent"],
        status: json["status"] == null ? undefined : json["status"],
        startsAt:
            json["startsAt"] == null ? undefined : new Date(json["startsAt"]),
        expiresAt:
            json["expiresAt"] == null ? undefined : new Date(json["expiresAt"]),
    };
}

export function OfferRequestToJSON(value?: OfferRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        name: value["name"],
        description: value["description"],
        discountPercent: value["discountPercent"],
        status: value["status"],
        startsAt:
            value["startsAt"] == null
                ? undefined
                : value["startsAt"].toISOString(),
        expiresAt:
            value["expiresAt"] == null
                ? undefined
                : value["expiresAt"].toISOString(),
    };
}
